<template>
    <div v-if="data.judgeRouter" class="headerMenu" style="border:0px;justify-content: flex-start;">
      <div class="home" @click="data.home">
        <img src="@/assets/home.png" alt="">
        <div class="text">回到首页</div>
      </div>
    </div>
    <div v-else class="headerMenu" :style="route.path !== '/'?'':'grid-template-columns: 1fr '">
      <div class="left" v-if="route.path !== '/'">
        <img src="@/assets/left.png" @click="data.home">
      </div>
      <div class="title" :class="route.meta.title==='私人画夹'?'coust':''" >
        {{  route.meta.title?route.meta.title:route.path=== '/appliance'?props.title:'花集AI精灵' }}
        <div v-if="route.path !== '/imgInfo'" class="samllTitle">{{  route.meta.tipFlag?'智慧伴你 随心所欲':props.tip }}
        <div v-if="route.meta.title==='私人画夹'" :class="store.userInfo && store.userInfo.member_level === 2?'vipIcon':'noVip'">
          VIP
        </div>
        </div>
      </div>
        <div @click="data.login" v-if="route.path !== '/personal' && route.meta.loginFlag && (store.generate || route.path !== '/appliance' )" :class="route.path !== '/'?'integral':'homeIntegral'">
          <div v-if="store.userInfo && store.userInfo.member_level" class="price">
            <img src="@/assets/price.png" alt="">
            <div class="num">{{ store.userInfo.petal_balance?store.userInfo.petal_balance:0 }}</div>
          </div>
          <div v-else>
            登录/注册
          </div>
        </div>
        <div class="quitLogin" @click="data.exitLanding" v-if="data.quitLogin && store.generate">
          退出登录
        </div>
      <div @click="data.goLinkPrivateClip" class="integral" style="color:#ffffff" v-if="!store.generate && route.name === 'appliance'">私人画夹</div>
    </div>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed } from 'vue';
import { useCounterStore } from '@/store'
import { useRoute, useRouter } from 'vue-router';
import { removeToken,removeTokenTime } from'@/ulits/auth'
import {getToken} from '@/ulits/auth'
/**
* 仓库
*/
const store = useCounterStore();
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
/**
* 数据部分
*/
const data = reactive({})
const props = defineProps({
  title: String,
  tip:String,
  type:String
});
data.login = () =>{
  const info  = localStorage.getItem('userInfo')
  localStorage.setItem('path',route.name)
  if (info && info!=='undefined' && getToken()) {
    data.userInfo = JSON.parse(info)
    router.push({
      name:route.name === 'appliance'?'appliancepersonal':'personal',
    })
    return
  }
  router.push({
    name:'login',
  })
}

data.home = () =>{
  if (localStorage.getItem('appInfo')) {
    data.appInfo = JSON.parse(localStorage.getItem("appInfo"))
  }
  if (route.name === 'appliance' && store.generate === false && data.appInfo && Number(data.appInfo.creation_type) === 3) {
    store.copywritingTrue()
    store.setGenerate(true)
    return false
  }
  let pay = localStorage.getItem('pay')
  let type = localStorage.getItem('type')
  if (route.name === 'appliancepersonal' || route.name === 'personal') {
    let path = localStorage.getItem('path')
    if (path) {
      router.replace({
        name:path
      })
    } else {
      router.replace({
        name:'home'
      })
    }

    localStorage.removeItem('path')
    return false
  }
  if (route.path === '/template') {
    if (type === '1') {
      router.push({
        name:'appliance'
      })
      return false
    }
    router.push({
      name:'personal'
    })
    return false
  }
  if (pay === 'true') {
    if (type) {
      localStorage.getItem('type')
      router.replace({
        name:'appliance'
      })
    } else {
      router.replace({
        name:'home'
      })
    }
    localStorage.setItem('pay',false)
    return false
  }
  if (route.path === '/imgInfo') {
    router.go(-1)
    return
  }
  if (route.path === '/loginIndex') {
    router.replace({
      name:'home'
    })
  return
  }
  if (route.meta.path) {
    router.replace({
      path:route.meta.path
    })
    return false
  }
  store.copywritingTrue()
    router.replace({
    name:'home'
  })
}

data.exitLanding = () =>{
  removeToken() 
  removeTokenTime()
  localStorage.removeItem('userInfo')
  localStorage.removeItem('code')
  store.setUserInfo({})
  store.setUndateFlag(false)
  router.replace({
    name:'home'
  })
}

data.titleFlag = computed(()=>{
  return route.path === '/personal' || route.path === '/template' ||route.path === '/appliancepersonal'||route.path === '/appliancetemplate'
})

data.quitLogin = computed(()=>{
  return route.path === '/personal' || route.path === '/appliancepersonal' 
})

data.judgeRouter = computed(()=>{
  return route.path === '/loginIndex'
})

data.getUserInfo = () =>{
  if (localStorage.getItem('userInfo') && getToken()) {
    data.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  }
}

data.goLinkPrivateClip = () => {
  router.push({
    path:"/paintings",
    query:{
      title:'私人画夹',
    }
  })
}
onBeforeMount(() => {
})
onMounted(() => {
data.getUserInfo()
})
watchEffect(()=>{
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
.coust{
  display: flex;
  justify-content: center;
  align-items: center;
}
.headerMenu{
  background: #111525;
  color: #ffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 112px;
  padding: 0 32px;
  position: relative;
  border-bottom: 1px solid #ffffff20;
  .home{
    cursor: pointer;
    font-size: 28px;
    display: flex;
    align-items: center;
    img{
      margin-right: 10px;
      width: 44px;
      height: 44px;
    }
    .text{
      margin-top: 6px;
    }
  }
  .title{
    text-align: center;
    font-size: 34px;
    width: 80%;
    .samllTitle{
      font-size: 22px;
    }
  }
  .left{
    position: absolute;
    left: 32px;
    img{
      cursor: pointer;
      width: 60px;
      height: 60px
    }
  }
  .integral{
    position: absolute;
    right: 32px;
    cursor: pointer;
    font-size: 30px;
    text-align: right;
    color: #8368FC;
    img{
      width: 48px;
      height: 48px;
    }
  }
  .homeIntegral{
    color: #8368FC;
    position: absolute;
    right: 32px;
    font-size: 30px;
    img{
      width: 48px;
      height: 48px;
    }
  }
  .quitLogin{
    position: absolute;
    right: 32px;
    text-align: right;
  }
}
.price{
  background: #E5DFFEFF;  
  min-width: 108px;
  height: 58px;
  padding: 0 22px;
  border-radius: 29px;
  display: flex;
  align-items: center;
}
.vipIcon{
  margin-left: 8px;
  width: 88px;
  height: 36px;
  line-height: 36px;
  background: linear-gradient(119deg, #FDDB9E 0%, #E3B15B 100%);
  border-radius: 8px;
  font-weight: bold;
  color: #291D0F;
  font-size: 30px;
  text-align: center;
  font-family: DINAlternate-Bold, DINAlternate;
}
.noVip{
  margin-left: 8px;
  width: 88px;
  height: 36px;
  line-height: 36px;
  background: linear-gradient(119deg, #CCCCCC 0%, #999999 100%);
  border-radius: 8px;
  font-weight: bold;
  color: #FFFFFF;
  font-size: 30px;
  text-align: center;
  font-family: DINAlternate-Bold, DINAlternate;
}
</style>

<style lang="scss" scoped>
// pc
@media (min-width: 600px){
  .headerMenu{
    height: 6vw;
    .title{
      font-size: 2vw;
      .samllTitle{
        font-size: 1vw;
      }
    }
    .integral{
      font-size: 2vw;
    }
    .homeIntegral{
      font-size: 2vw;
    }
    .home{
      cursor: pointer;
      font-size: 1vw;
      display: flex;
      align-items: center;
      img{
        margin-right: 10px;
        width: 1.5vw;
        height: 1.5vw;
      }
      .text{
        margin-top: 6px;
      }
    }
  }
}
</style>